import React, { useCallback, useEffect, useRef, useState } from 'react';
import { MCButton, MCError } from '../basic';
import { lang, remCss, api } from 'src/helpers';
import LANG_CONST from '../../helpers/lang/const';
import SlotCalendar from '../appointments/SlotCalendar';
import mainModel, { models, STEPS } from './model';
import { BASE_ICONS } from 'components/svg';
import moment from 'moment';

const model = models[STEPS.RESCHEDULE];

const mergeToUnsavedSlot = (dbSlots, from, to) => {
  const { unsavedSlots, list: bookedList, params } = models[STEPS.BOOKED_LIST].state;
  const { startDate, endDate } = params;

  const data = unsavedSlots.filter(
    (slot) =>
      ((slot.startDate >= from && slot.startDate <= to) ||
        (slot.endDate >= to && slot.endDate <= to)) &&
      !bookedList.find((b) => b.rescheduleSlotId === slot.id)
  );
  dbSlots.forEach((slot) => {
    if (
      !(
        (slot.startDate >= startDate && slot.startDate <= endDate) ||
        (slot.endDate >= startDate && slot.endDate <= endDate)
      ) &&
      !bookedList.find((b) => b.rescheduleSlotId === slot.id)
    ) {
      data.push(slot);
    }
  });

  return data;
};

export const Reschedule = ({ onPrev, onDone }) => {
  const [type, setType] = useState(null);
  const [slot, setSlot] = useState(null);
  const [day, setDay] = useState(model.state.selectedDay);
  const [slots, setSlots] = useState([]);
  const [payLifeapp, setPayLifeapp] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const calendarRef = useRef(null);

  model.use();

  const loadList = useCallback(
    (d = null) => {
      d = d || day;
      mainModel.getSlots(d, (err, data) => {
        if (err) return;

        const list = model.state.editAppointmentId
          ? data
          : mergeToUnsavedSlot(
              data,
              moment(d).startOf('month').valueOf(),
              moment(d).endOf('month').valueOf()
            );

        const availableSlot = list[0];
        setDay(availableSlot?.startDate || d);
        setSlot(availableSlot);
        setType(availableSlot?.appointmentTypes[0]);
        setSlots(list);
        setTimeout(() => calendarRef.current?.scrollToDate(), 500);
      });
    },
    [day]
  );

  useEffect(() => {
    loadList();

    return () => {
      mainModel.cancelApi('getSlots');
    };
  }, []);

  return (
    <>
      <div className='mc-modal-header mc-flex'>
        {onPrev && (
          <MCButton
            width={40}
            iconname={BASE_ICONS.BACK_ARROW}
            primary
            onClick={onPrev}
            style={{ marginVertical: -10 }}
          />
        )}
        <div className='mc-popup-title'>{lang.t(LANG_CONST.buttons.reschedule)}</div>
      </div>
      <div className='mc-modal-body mc-grow mc-flex-15-col'>
        <div className={'mc-grow mc-flex-20-col mc-book-doctor'}>
          <SlotCalendar
            ref={calendarRef}
            fees={mainModel.getFees()}
            currency={mainModel.getCurrency()}
            loading={mainModel.getApiState('getSlots').loading}
            slots={slots}
            selectedDay={day}
            selectedSlot={slot}
            selectedType={type}
            payLifeapp={payLifeapp}
            handleChangeSelectedMonth={(v) => {
              setDay(v);
              loadList(v);
            }}
            handleChangeSelectedDay={(v) => {
              setDay(v);
              setType(null);
              setSlot(null);
            }}
            handleChangeSelectedSlot={(v) => {
              setSlot(v);
              setType(v.appointmentTypes[0]);
              setDay(v.startDate);
            }}
            handleChangeSelectedType={setType}
            isPatient={false}
            handleChangePayNow={null}
            handleChangePayLifeapp={setPayLifeapp}
          />
        </div>
      </div>
      <div className='mc-modal-footer' style={{ gap: remCss(20) }}>
        {error && <MCError error={error} label={LANG_CONST.slot} />}
        <div className={'mc-grow'} />
        <MCButton
          medium
          dark
          radius
          primary
          loading={loading}
          label={LANG_CONST.buttons.reschedule}
          onClick={useCallback(
            (e) => {
              if (!slot) {
                setError(LANG_CONST.validation.required);
              } else if (model.state.editAppointmentId) {
                setLoading(true);
                api('appointment/update', {
                  id: model.state.editAppointmentId,
                  slotId: slot.id,
                  appointmentType: type,
                  payLifeapp: payLifeapp
                }).then(({ error }) => {
                  if (error) return setError(error);
                  onDone(e);
                  setLoading(false);
                });
              } else {
                const { list } = models[STEPS.BOOKED_LIST].state;
                models[STEPS.BOOKED_LIST].setStateSilent({
                  list: list.map((item) =>
                    item.id === model.state.editId
                      ? {
                          ...item,
                          resolvedType: 'reschedule',
                          rescheduleSlotId: slot.id,
                          rescheduleStartDate: slot.startDate,
                          rescheduleEndDate: slot.endDate,
                          rescheduleType: type
                        }
                      : item
                  )
                });
                mainModel.backStep(e);
              }
            },
            [slot, type, onDone, payLifeapp]
          )}
        />
      </div>
    </>
  );
};
